import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { Validator } from 'vee-validate'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en: require('./i18n/translations_en')
  }
})

const loadedLocales = ['en']

export async function setLocale(locale) {
  locale = locale || 'en'

  let success = true

  if (!loadedLocales.includes(locale)) {
    // Lade i18n locale
    try {
      let localeFile = locale.replace('-','_')
      const messages = await import(/* webpackChunkName: "i18n-[request]" */ `./i18n/translations_${localeFile}`)
      i18n.setLocaleMessage(locale, messages)
    } catch (e) {
      console.error(`Unable to load i18n locale ${locale}`)
      success = false
    }

    try {
      const veeValidateMessages = await import(/* webpackChunkName: "vee-validate-[request]" */ `vee-validate/dist/locale/${locale}`)
      Validator.localize({
        [locale]: veeValidateMessages
      })
    } catch (e) {
      console.error(`Unable to load vee-validate locale ${locale}`)
      success = false
    }

    if (success) loadedLocales.push(locale)
  }

  i18n.locale = locale
  Validator.localize(locale)
}
